import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { JobFilterEntity } from '../../domain/entities/JobFilterEntity'

export class JobFilterModel extends JobFilterEntity {
  regionId?: number
  driverId?: number
  fromDate?: string
  toDate?: string
  constructor(dataDto: JobFilterEntity) {
    super()
    mapEntityProperties<JobFilterModel>(this, dataDto, {
      exclude: ['region', 'driver', 'date'],
      map: {
        regionId: dataDto.region?.id,
        driverId: dataDto.driver?.id,
        fromDate: dataDto.date ? dataDto.date[0] : undefined,
        toDate: dataDto.date ? dataDto.date[1] : undefined
      }
    })
  }
}
